import React from 'react';
import { useModal } from '../../../../../../components/Modal/PresentedModal';
import { useForm } from '@nerdgeschoss/react-use-form-library';
import { t } from '../../../../../../locales/translate';
import { Button } from '../../../../../../components/Button/Button';
import { graphql } from '../../../../../../generated';
import { useMutation, useSuspenseQuery } from '@apollo/client';
import { FormCheckbox } from '../../../../../../components/Form/Checkbox/FormCheckbox';

interface Props {
  productId: string;
}

const PASSBOOK_CONFIG = graphql(`
  query PassbookConfigForEdit($id: ID!) {
    event(id: $id) {
      id
      permissions {
        id
        updatePassbookConfig
      }
      passbookConfig {
        id
        enabled
      }
    }
  }
`);

const UPDATE_PASSBOOK = graphql(`
  mutation UpdatePassbookConfig($id: ID!, $enabled: Boolean) {
    updatePassbookConfig(input: { id: $id, enabled: $enabled }) {
      passbookConfig {
        id
        enabled
      }
    }
  }
`);

export function EditPassbook({ productId }: Props): JSX.Element {
  const { open, Modal, close } = useModal();
  const { data } = useSuspenseQuery(PASSBOOK_CONFIG, { variables: { id: productId } });
  const [update] = useMutation(UPDATE_PASSBOOK);
  const { fields, onSubmit, valid, submissionStatus } = useForm<{ enabled?: boolean }>({
    model: { enabled: data.event.passbookConfig.enabled },
    onSubmit: async ({ model }) => {
      await update({ variables: { id: productId, enabled: model.enabled ?? false } });
      close();
    },
  });
  return (
    <Modal
      open={open}
      title={t.page.event.design.passbook.edit.title}
      footer={
        <>
          <Button
            title={t.actions.cancel('')}
            onClick={() => {
              close();
            }}
          />
          <Button
            type="primary"
            title={t.actions.save('')}
            onClick={onSubmit}
            disabled={!valid}
            loading={submissionStatus === 'submitting'}
          />
        </>
      }
    >
      <FormCheckbox label={t.page.event.design.passbook.edit.enabled} {...fields.enabled} />
    </Modal>
  );
}
